/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StatusCategory } from './StatusCategory';
import {
    StatusCategoryFromJSON,
    StatusCategoryFromJSONTyped,
    StatusCategoryToJSON,
    StatusCategoryToJSONTyped,
} from './StatusCategory';
import type { StatusChange } from './StatusChange';
import {
    StatusChangeFromJSON,
    StatusChangeFromJSONTyped,
    StatusChangeToJSON,
    StatusChangeToJSONTyped,
} from './StatusChange';

/**
 * 
 * @export
 * @interface ProjectStatusUpdate
 */
export interface ProjectStatusUpdate {
    /**
     * 
     * @type {StatusCategory}
     * @memberof ProjectStatusUpdate
     */
    category?: StatusCategory;
    /**
     * 
     * @type {StatusChange}
     * @memberof ProjectStatusUpdate
     */
    change?: StatusChange;
    /**
     * 
     * @type {any}
     * @memberof ProjectStatusUpdate
     */
    statusId?: any | null;
}



/**
 * Check if a given object implements the ProjectStatusUpdate interface.
 */
export function instanceOfProjectStatusUpdate(value: object): value is ProjectStatusUpdate {
    return true;
}

export function ProjectStatusUpdateFromJSON(json: any): ProjectStatusUpdate {
    return ProjectStatusUpdateFromJSONTyped(json, false);
}

export function ProjectStatusUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectStatusUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'] == null ? undefined : StatusCategoryFromJSON(json['category']),
        'change': json['change'] == null ? undefined : StatusChangeFromJSON(json['change']),
        'statusId': json['statusId'] === undefined ? undefined : json['statusId'] === null ? null : json['statusId'],
    };
}

export function ProjectStatusUpdateToJSON(json: any): ProjectStatusUpdate {
    return ProjectStatusUpdateToJSONTyped(json, false);
}

export function ProjectStatusUpdateToJSONTyped(value?: ProjectStatusUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': StatusCategoryToJSON(value['category']),
        'change': StatusChangeToJSON(value['change']),
        'statusId': value['statusId'],
    };
}

